import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { SideListOptionType } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { FiMediaBankService } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-insert-media-details-filter',
    templateUrl: './fi-insert-media-details-filter.component.html',
    styleUrls: ['./fi-insert-media-details-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-insert-media-details-filter' },
    standalone: false,
})
export class FiInsertMediaDetailsFilterComponent implements OnInit {
    @Output() onClearFilters = new EventEmitter<void>();
    @Input() selectedFilterTypes: number[] = [];
    @Output() onSelectedOptionsMainChanged = new EventEmitter<number[]>();
    @Input() selectedFilterTypePeriods: number[] = [];
    @Output() onSelectedOptionsPeriodChanged = new EventEmitter<number[]>();
    @Input() selectedTagIds: number[] = [];
    @Output() onSelectedOptionsTagsChanged = new EventEmitter<number[]>();
    @Output() onHideFilters = new EventEmitter<void>();

    sideListOptionsMain: ISideListOptionsItem[];
    sideListOptionsPeriod: ISideListOptionsItem[];
    sideListOptionsTags: ISideListOptionsItem[] = [];

    constructor(
        private appTextService: AppTextService,
        private fiMediaBankService: FiMediaBankService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.setFilterOptionsData();
    }

    private setFilterOptionsData() {
        this.sideListOptionsMain = [
            {
                text: this.appTextService.get('common.new_files'),
                value: SideListOptionType.OnlyNotSeen,
            },
            {
                text: this.appTextService.get('mediaModule.my_files'),
                value: SideListOptionType.CreatedBy,
            },
            {
                text: this.appTextService.get('common.my_favorites'),
                value: SideListOptionType.Favorite,
            },
        ];

        this.sideListOptionsPeriod = [
            {
                text: this.appTextService.get('common.last_day'),
                value: SideListOptionType.LastDay,
            },
            {
                text: this.appTextService.get('common.last_week'),
                value: SideListOptionType.LastWeek,
            },
            {
                text: this.appTextService.get('common.last_month'),
                value: SideListOptionType.LastMonth,
            },
            {
                text: this.appTextService.get('common.last_quarter'),
                value: SideListOptionType.LastQuarter,
            },
        ];

        this.fiMediaBankService.getMediaBankFileTags().then((tags) => {
            this.sideListOptionsTags = tags.map((tag) => ({
                text: tag.Name,
                value: tag.Id,
            }));
            this.cdr.detectChanges();
        });
    }

    clearFilters() {
        this.selectedFilterTypes = [];
        this.selectedFilterTypePeriods = [];
        this.selectedTagIds = [];
        this.onClearFilters.emit();
    }

    selectedOptionsMainChanged(selectedOptionValues: number[]) {
        this.onSelectedOptionsMainChanged.emit(selectedOptionValues);
    }

    selectedOptionsPeriodChanged(selectedOptionValues: number[]) {
        this.onSelectedOptionsPeriodChanged.emit(selectedOptionValues);
    }

    selectedOptionsTagsChanged(selectedOptionValues: number[]) {
        this.onSelectedOptionsTagsChanged.emit(selectedOptionValues);
    }

    hideFilters() {
        this.onHideFilters.emit();
    }
}
